exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] #tailwind-grid-demo .bg-grid-color {\n  background-color: #b8c2cc;\n}\n[dir] #tailwind-grid-demo .bg-grid-color-secondary {\n  background-color: #dae1e7;\n}\n[dir] .theme-dark #tailwind-grid-demo .bg-grid-color {\n  background-color: #262c49;\n}\n[dir] .theme-dark #tailwind-grid-demo .bg-grid-color-secondary {\n  background-color: #414561;\n}", ""]);

// exports
